module.exports = __webpack_public_path__ + "static/media/under_construction.71774987.gif";